module.exports = __webpack_public_path__ + "static/garlic-755a0d424823d5d5289c76f6bce0eafc.jpg";